import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { PRODUCT_NAME } from '../data/constants';
const THOUGHTS = ['“I’ve never sold baked goods before.”', '“I don’t know if mine will look professional.”', '“I don’t know enough about baking.”', '“I don’t have a bakery.”'];
const STEPS = ['First, learn to make it.', 'Then make it consistent.', 'Then create variations.', 'Then improve the presentation.'];
const TODAY = ['Ingredients sitting in your kitchen.', 'Recipes saved on your phone.', 'Ideas you’ve never turned into anything.'];
const TOMORROW = ['Your own cinnamon roll recipe.', 'Your own flavor combinations.', 'Your own finished product.', 'Something real you created.', 'Something you can put in a box.', 'Something you can show someone.', 'Something you can sell.'];
export function ObjectionsSection() {
  return <>
      <section className="bg-cream px-4 py-6" data-id="element-105" data-mp="32sivyrz43pyz">
        <div className="mx-auto max-w-3xl" data-id="element-106" data-mp="37o7waxiyhawc">
          <h2 className="text-center text-xl text-espresso sm:text-3xl" data-id="element-107" data-mp="37r3vep6ji5md">
            You Don&apos;t Need To Have Everything Figured Out Before You Start
          </h2>
          <p className="mt-2 text-sm font-semibold text-espresso/80 sm:text-base" data-id="element-108" data-mp="5rcbq382k1uk">You may be thinking:</p>
          <ul className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-109" data-mp="jr3o5zixta6g">
            {THOUGHTS.map(thought => <li key={thought} className="rounded border-l-4 border-cinnamon bg-white px-3 py-2 text-sm font-semibold italic text-espresso/80" data-id="element-110" data-mp="etbt4wmzx7y1">
                {thought}
              </li>)}
          </ul>
          <p className="mt-3 text-sm font-extrabold text-espresso sm:text-base" data-id="element-111" data-mp="tszf8uxlz59">
            That&apos;s exactly why the system starts with the product.
          </p>
          <ol className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-112" data-mp="34hukayr92epb">
            {STEPS.map((step, index) => <li key={step} className="flex items-center gap-2 text-sm font-bold text-cinnamon" data-id="element-113" data-mp="2zjjdkww94kbb" data-mpi={index}>
                {step}
                {index < STEPS.length - 1 ? <ArrowRightIcon className="h-4 w-4 text-burnt" aria-hidden="true" data-id="element-114" data-mp="18epwru79gikk" /> : null}
              </li>)}
          </ol>
          <p className="mt-2 text-sm font-semibold text-espresso/85 sm:text-base" data-id="element-115" data-mp="1d6r89dwlu59j">
            Then you have something tangible you can begin building around.
          </p>
          <p className="mt-1 text-base font-extrabold text-burnt sm:text-lg" data-id="element-116" data-mp="khk8kblez9mp">
            You don&apos;t need to start with a bakery. You need to start with a product.
          </p>
        </div>
      </section>

      <section className="bg-espresso px-4 py-6 text-cream" data-id="element-117" data-mp="udvkh0h3dxgm">
        <div className="mx-auto max-w-4xl" data-id="element-118" data-mp="ygjwti50lmic">
          <h2 className="text-center text-xl sm:text-3xl" data-id="element-119" data-mp="yhbhvz0zk1ud">
            From Flour To <span className="text-gold" data-id="element-120" data-mp="25un28aushj2m">A Product You Can Sell</span>
          </h2>
          <p className="mt-1 text-center text-sm font-semibold text-cream/80" data-id="element-121" data-mp="29vf8cv8d77uo">Think about the transformation.</p>
          <div className="mt-3 grid gap-3 sm:grid-cols-2" data-id="element-122" data-mp="3ue99u5nf9oax">
            <div className="rounded-lg border-2 border-cream/20 bg-espressoLight p-3.5" data-id="element-123" data-mp="3ufu2tqu38z6o">
              <h3 className="text-base text-cream/70" data-id="element-124" data-mp="3qcxquiz201bp">Today:</h3>
              <ul className="mt-1.5 space-y-1 text-sm font-semibold text-cream/70" data-id="element-125" data-mp="3lke5v0y1e3wv">
                {TODAY.map(item => <li key={item} data-id="element-126" data-mp="3gm2u2ko6ljc0">{item}</li>)}
              </ul>
            </div>
            <div className="rounded-lg border-2 border-gold bg-espressoLight p-3.5" data-id="element-127" data-mp="3bot5f78m9bp8">
              <h3 className="text-base text-gold" data-id="element-128" data-mp="36ndpftlapvdp">Tomorrow:</h3>
              <ul className="mt-1.5 space-y-1 text-sm font-bold text-cream" data-id="element-129" data-mp="32m1tl6btwdx2">
                {TOMORROW.map(item => <li key={item} data-id="element-130" data-mp="2xoifc6f4s154">{item}</li>)}
              </ul>
            </div>
          </div>
          <p className="mt-3 text-center text-sm font-extrabold text-gold sm:text-base" data-id="element-131" data-mp="10tvv6hzwxd0t">
            That&apos;s the opportunity {PRODUCT_NAME} is designed to help you create.
          </p>
        </div>
      </section>
    </>;
}